import { render, staticRenderFns } from "./modalPhotosReview.vue?vue&type=template&id=6be7d892"
import script from "./modalPhotosReview.vue?vue&type=script&lang=js"
export * from "./modalPhotosReview.vue?vue&type=script&lang=js"
import style0 from "./modalPhotosReview.vue?vue&type=style&index=0&id=6be7d892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports